import { render, staticRenderFns } from "./irt.html?vue&type=template&id=4e20406e&"
import script from "./irt.js?vue&type=script&lang=js&"
export * from "./irt.js?vue&type=script&lang=js&"
import style0 from "./irt.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports